import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import ItemAnalysisReport from "./ItemAnalysisReport";
import FuelConsumptionReport from "./fuelConsumptionReport";
import ItemGroupType from "./ItemGroupTypeReport";
import { hasPermission } from "../utils/usePermissions";
const ItemAndGroupAnalysisReports = ({ accessOfDepartments, permissions }) => {
  const [selectedReport, setSelectedReport] = useState("");

  /* ================= RENDER SELECTED REPORT ================= */
  const renderReport = () => {
    switch (selectedReport) {
      case "overallItemAnalysis":
        return <ItemAnalysisReport accessOfDepartments={accessOfDepartments} />;

      case "fuelConsumption":
        return <FuelConsumptionReport accessOfDepartments={accessOfDepartments} />;

      case "itemGroupList":
        return <ItemGroupType accessOfDepartments={accessOfDepartments} />;

      default:
        return (
          <div className="text-muted mt-4">
            Please select a report
          </div>
        );
    }
  };
  const getCheckboxStyle = (checked) => ({
    width: "18px",
    height: "18px",
    border: "3px solid #198754",
    borderRadius: "2px",
    appearance: "none",
    cursor: "pointer",
    backgroundColor: checked ? "#198754" : "#fff",
  });

  const labelStyle = { cursor: "pointer" };

  return (
    <div className="container-fluid mt-5">
      <div className="card">
        <div className="card-body">
          {/* <h5 className="mb-3">Item Wise Reports</h5> */}

          {/* ================= RADIO OPTIONS ================= */}
          <div className="row">

            {hasPermission(permissions, ['itemAnalysis'])?
            <div className="col-md-4">
              <div className="form-check d-flex align-items-center gap-2">
                <input
                  type="checkbox"
                  id="overallItemAnalysis"
                  checked={selectedReport === "overallItemAnalysis"}
                  onChange={() => setSelectedReport("overallItemAnalysis")}
                  style={getCheckboxStyle(selectedReport === "overallItemAnalysis")}
                />
                <label htmlFor="overallItemAnalysis" style={labelStyle}>
                  Overall Item Analysis
                </label>
              </div>
            </div>:
            null}

            {hasPermission(permissions, ['itemGroupList'])?
            <div className="col-md-4">
              <div className="form-check d-flex align-items-center gap-2">
                <input
                  type="checkbox"
                  id="fuelConsumption"
                  checked={selectedReport === "fuelConsumption"}
                  onChange={() => setSelectedReport("fuelConsumption")}
                  style={getCheckboxStyle(selectedReport === "fuelConsumption")}
                />
                <label htmlFor="fuelConsumption" style={labelStyle}>
                  Fuel Consumption
                </label>
              </div>
            </div>:
            null}

            {hasPermission(permissions, ['fuelConsumptionReport'])?
            <div className="col-md-4">
              <div className="form-check d-flex align-items-center gap-2">
                <input
                  type="checkbox"
                  id="itemGroupList"
                  checked={selectedReport === "itemGroupList"}
                  onChange={() => setSelectedReport("itemGroupList")}
                  style={getCheckboxStyle(selectedReport === "itemGroupList")}
                />
                <label htmlFor="itemGroupList" style={labelStyle}>
                  Item Group List
                </label>
              </div>
            </div>:
            null}

          </div>


        </div>
      </div>

      {/* ================= REPORT CONTENT ================= */}
      <div className="mt-3">{renderReport()}</div>
    </div>
  );
};

export default ItemAndGroupAnalysisReports;
